<div
  class="rounded-lg border bg-card text-card-foreground shadow-xs h-full overflow-hidden flex flex-col"
>
  <div class="h-fit flex flex-row items-center justify-between space-y-1.5 p-6">
    <h3 class="text-2xl font-semibold leading-none tracking-tight">
      Inventario
    </h3>

    <button class="primary normal" (click)="openModal()">+ Nuevo Rollo</button>
  </div>

  <div
    class="grow h-full flex items-start p-6 pt-0 overflow-x-auto overflow-y-auto scrollbar-thin scrollbar-thumb-slate-500 scrollbar-track-slate-200"
  >
    <div class="h-full w-full">
      <table class="w-full table-auto">
        <thead>
          <tr class="border-b border-border">
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Producto
            </th>
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              SKU
            </th>
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Categorías
            </th>
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Rollos
            </th>
            <th
              class="text-right py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Total <br />(m)
            </th>
            <th
              class="text-right py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Total <br />(kg)
            </th>
            <th
              class="text-right py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Reservado <br />(m)
            </th>
            <th
              class="text-right py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Reservado <br />(kg)
            </th>
            <!-- <th
              class="text-center py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Acciones
            </th> -->
          </tr>
        </thead>

        <tbody>
          @for(product of products; track product.id) {
          <tr
            class="[&:not(:last-child)]:border-b border-border hover:bg-accent transition-colors"
            (click)="selectProduct(product)"
          >
            <td class="py-4 px-4">
              <div class="flex items-center space-x-3">
                <div
                  class="w-10 h-10 bg-secondary rounded-lg flex items-center justify-center shrink-0"
                >
                  <ng-icon
                    name="lucidePackage"
                    class="w-5 h-5 text-secondary-foreground"
                  />
                </div>
                <div>
                  <!-- <p class="text-foreground font-medium">{{ category.name }}</p> -->
                  <p class="text-foreground font-medium text-sm">
                    {{ product.name }}
                  </p>
                  <p class="text-muted-foreground text-xs">
                    {{ product.description }}
                  </p>
                </div>
              </div>
            </td>
            <td class="py-4 px-4 text-muted-foreground text-[0.65rem]">
              {{ product.sku }}
            </td>
            <td class="py-4 px-4 w-1/5">
              <div class="flex flex-row items-center flex-wrap gap-1">
                @for(category of product.product_categories; track category.id)
                {
                <span
                  class="px-2.5 py-0.5 rounded-full text-xs font-medium border text-nowrap text-[0.55rem]"
                >
                  {{ category.name }}
                </span>
                }
              </div>
            </td>
            <td class="py-4 px-4 w-1/5">
              <div class="flex items-center gap-1 flex-wrap">
                @for (color of product.colors; track color.color) {
                <app-color-total
                  [color]="color.color"
                  [total]="color.roll_count"
                ></app-color-total>
                }
              </div>
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-right">
              {{ product.total_available_length_meters | number : "1.2-2" }}
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-right">
              {{ product.total_available_weight_kg | number : "1.2-2" }}
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-right">
              {{ product.total_reserved_length_meters | number : "1.2-2" }}
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-right">
              {{ product.total_reserved_weight_kg | number : "1.2-2" }}
            </td>
            <!-- <td class="py-4 px-4">
              <div class="flex items-center justify-center space-x-1">
                <button class="ghost sm text-destructive">
                  <ng-icon
                    name="lucideTrash2"
                    class="w-5 h-5 text-secondary-foreground"
                  />
                </button>
              </div>
            </td> -->
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-roll-form
  [(showModal)]="showModal"
  [(existingRoll)]="existingRoll"
></app-roll-form>
